import CustomSelect from '../demos/CustomSelect';

export default [
  { path: "/demos/CustomSelect", name: "Isolated Custom Select", Component: CustomSelect }
];
